import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  loading: {
    width:'50vw',
    position: 'fixed',
    top: '45vh',
    left: '0',
    transform: 'translate(calc(50vw - 50%))',
  },
  header:{
    marginTop:'1rem',
    height: '7vh',
    marginBottom: '2vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logo: {
    height: '90%',
    maxWidth: '20vw',
    minWidth: '300px',
    objectFit: 'contain',
    display:'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logoIcon:{
    height: '100%',
    width: '60px'
  },
  switcher:{
    display:'flex',
    alignItems:'center'
  },
  container: {
    padding: '0 2rem 2rem 2rem',
    '@media (max-width: 520px)': {
      padding: '0 8px 8px 8px'
    }
  },
  mainLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridRowGap: '2rem',
      maxWidth: '1600px',
      marginLeft: 'auto',
      marginRight: 'auto',
  }
}));